import { RootState } from '../store'

export const selectUsers = (state: RootState) => state.users.users
export const selectCurrency = (state: RootState) => state.users.currency
export const selectUsersLoading = (state: RootState) => state.users.loading
export const selectUsersError = (state: RootState) => state.users.error
export const selectActivateMessage = (state: RootState) =>
  state.users.activateMessage
export const selectUpdateProfileMessage = (state: RootState) =>
  state.users.updateProfileMessage
